import React from 'react';
import {View} from 'react-native';

import {Code, FlexView, Heading, Spacing} from '/component/base/Storybook';
import Gutter from '/component/layout/Gutter';

import DeltaListItem from '../DeltaListItem';

import {styles} from './DeltaListItem.style';

export default () => (
  <>
    <Spacing size={20}>
      <Heading level={1}>Readonly</Heading>
    </Spacing>
    <View style={styles.wrapper}>
      <Gutter style={styles.gutter}>
        <DeltaListItem
          readonly
          heading="Commissions"
          subheading="Last month"
          total={123456}
          delta={42}
        />
      </Gutter>
    </View>
    <FlexView>
      <Spacing size={20}>
        <Code>{'readonly={true}'}</Code>
      </Spacing>
    </FlexView>
  </>
);
